import type { JiraSideNav } from '@post-office/placement-create-pipeline/pipes';

import { createClientPipeline } from '@post-office/placement-create-pipeline/create-pipeline';

import { type MessageTemplateContext } from '../../..';

import { type JSX } from 'react/jsx-runtime';

export type HydrationResult = {
	entitlementId: string;
	productName: string;
	edition: string;
	placeOrderHref: string;
	shouldForceOpenModal: boolean;
};

type Pipe = JiraSideNav<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

const clientPipeline = createClientPipeline<Pipe>();

export const createRender: <
	U extends (renderProps: HydrationResult & { onDismissed: () => void }) => JSX.Element | null,
>(
	render: U,
) => (renderProps: HydrationResult & { onDismissed: () => void }) => JSX.Element | null =
	clientPipeline.createRender;
